import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {languages} from "../language";

import type Language from "./language.model";
import type {Subscription} from "rxjs";

@Component({
    selector: 'app-lang-manager',
    templateUrl: './lang-manager.component.html',
    styleUrls: ['./lang-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LangManagerComponent implements OnInit, OnDestroy {
  private translateService = inject(TranslateService);


  private readonly storageAskedPrem = 'askedPermission';
  readonly languages = languages;

  lang: Language;

  sub: Subscription;

  ngOnInit(): void {
    this.lang = this.languages.find(e => e.code === this.translateService.currentLang());
    this.sub = this.translateService.onLangChange.subscribe(lang => this.lang = this.languages.find(e => e.code === lang.lang));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  setLang(lang: Language) {
    this.translateService.use(lang.code);
    localStorage.setItem(this.storageAskedPrem, JSON.stringify(lang));
  }

}
